import script from "./OrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderList.vue?vue&type=script&setup=true&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=d7e934ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7e934ec"]])

export default __exports__